/**
 * Transforms relative Strapi upload URLs ("/uploads/...") to absolute URLs
 * using the GATSBY_STRAPI_API_URL environment variable.
 *
 * Works in both build-time (gatsby-node) and client-side contexts.
 * Safe to call with any value — returns non-upload strings unchanged.
 */
export function fixStrapiUrl(url: string | null | undefined): string {
  if (!url) return "";
  if (!url.startsWith("/uploads/")) return url;
  const base = (process.env.GATSBY_STRAPI_API_URL || process.env.STRAPI_API_URL || "").replace(/\/$/, "");
  if (!base) return url;
  return `${base}${url}`;
}
